"use client";

import React from "react";

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  hideLabel?: boolean;
  styleClass: string;
  labelClass?:string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  icon,
  hideLabel = false,
  styleClass,
  labelClass,
  ...props
}) => {
  const classes = [
    "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer",
    styleClass,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button onClick={onClick} className={classes} {...props}>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {hideLabel ? (
        <span className={`sr-only ${labelClass}`}>{label}</span>
      ) : (
        <span className={labelClass}>{label}</span>
      )}
    </button>
  );
};

export default Button;
